import React from 'react';
import { motion } from 'framer-motion';
import { ATTENTION, ENGAGED } from '../../data/insights';
const EASE = [0.23, 1, 0.32, 1] as const;
export function AttentionChart() {
  const max = Math.max(...ATTENTION.map(a => a.share));
  return <section aria-labelledby="attention-title" className="flex flex-col rounded-2xl bg-white p-5 lg:col-span-7" data-id="element-55" data-mp="t91lejwkzatt">
      <h3 id="attention-title" className="text-[13px] font-semibold text-ink" data-id="element-56" data-mp="oc1ek6rwq41n">
        Engagement across clinical topics
      </h3>
      <p className="mt-1 text-[12px] text-graphite" data-id="element-57" data-mp="1gxub3ymm0mfz">
        Share of engaged HCPs (n = {ENGAGED.toLocaleString('en-GB')}) interacting with each topic
      </p>
      <ul className="mt-5 space-y-4" data-id="element-58" data-mp="1c5j8go0himjq">
        {ATTENTION.map((a, i) => {
        const top = a.share === max;
        return <li key={a.label} data-id="element-59" data-mp="24ogj5pwm66pz" data-mpi={i}>
              <div className="flex items-baseline justify-between gap-3" data-id="element-60" data-mp="24oq8rcdqybv5">
                <p className="min-w-0 truncate text-[13px] text-ink" data-id="element-61" data-mp="1zwyf2szanq0s">
                  <span className={top ? 'font-semibold' : ''} data-id="element-62" data-mp="pb5lob68ni6h">{a.label}</span>
                  <span className="ml-2 text-[11px] text-graphite/80" data-id="element-63" data-mp="pd8lto13urox">{a.source}</span>
                </p>
                <span className={`tabular font-serif text-[17px] ${top ? 'text-teal' : 'text-ink'}`} data-id="element-64" data-mp="uc348ov5ue8i">{a.share}%</span>
              </div>
              <div className="mt-1.5 h-[7px] overflow-hidden rounded-full bg-stage" data-id="element-65" data-mp="kjnlhpc1hlmk">
                <motion.div className={`h-full origin-left rounded-full ${top ? 'bg-teal' : 'bg-navy/70'}`} style={{
              width: `${a.share}%`
            }} initial={{
              scaleX: 0
            }} animate={{
              scaleX: 1
            }} transition={{
              duration: 0.3,
              delay: 0.15 + i * 0.05,
              ease: EASE
            }} data-id="element-66" data-mp="6kxn86dhhfwm" />
              </div>
            </li>;
      })}
      </ul>
    </section>;
}